import { useState } from "react";
import { TaskStandAloneAlarm } from "shared/api";

export const useTaskHubState = () => {
  // UI / Modal states
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isAddModalStandAloneOpen, setIsAddModalStandAloneOpen] =
    useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isEditStandAloneOpen, setIsEditStandAloneOpen] = useState(false);
  const [isChartOpen, setIsChartOpen] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isEditAlarmOpen, setIsEditAlarmOpen] = useState(false);

  // Editing / selection states
  const [editingTask, setEditingTask] = useState<number | null>(null);
  const [editingStandAloneId, setEditingStandAloneId] = useState<number | null>(
    null
  );
  const [selectedTaskId, setSelectedTaskId] = useState<number | null>(null);
  const [editingAlarm, setEditingAlarm] = useState<TaskStandAloneAlarm | null>(
    null
  );

  return {
    // modals
    isAddModalOpen,
    setIsAddModalOpen,
    isAddModalStandAloneOpen,
    setIsAddModalStandAloneOpen,
    isEditModalOpen,
    setIsEditModalOpen,
    isEditStandAloneOpen,
    setIsEditStandAloneOpen,
    isChartOpen,
    setIsChartOpen,
    isCalendarOpen,
    setIsCalendarOpen,
    isEditAlarmOpen,
    setIsEditAlarmOpen,

    // editing
    editingTask,
    setEditingTask,
    editingStandAloneId,
    setEditingStandAloneId,
    selectedTaskId,
    setSelectedTaskId,
    editingAlarm,
    setEditingAlarm,
  };
};
